import { Sites } from '@ps/platform-message-framework/common/Sites';
import type { States } from '@ps/web-core-intl';

import { Country } from '@swf/core/enums';
import states from '@swf/generated/states.json';

import { communityList, communityMap } from './spain-community-list';

export interface CommunityAttribute {
  siteId: Sites;
  locale: string;
}

interface Item {
  text: string;
  value: string;
}

// @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
export const getSpainCommunity = (stateId: string): string => communityMap[stateId]?.value || '';

// @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
export const getSpainCommunityList = (locale: string): Item[] => communityList[locale] || [];

export const getCountryStates = (
  selectedCountry: string,
  communityAttribute?: CommunityAttribute
): States =>
  selectedCountry === Country.Spain && communityAttribute && communityAttribute.siteId === Sites.SPA
    ? getSpainCommunityList(communityAttribute.locale)
    : states[selectedCountry] || [];
